import { inject, Injectable } from '@angular/core';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { ToastService } from '@skylab-angular-shared/ui';
import { ConsoleLogger } from '@skylab-shared/core';
import { ToastDelay } from '@skylab-shared/ui';
import { ClipboardUtils } from '@skylab-shared/utils';

@Injectable({ providedIn: 'root' })
export class CopyToClipboardService {
    private readonly toastService = inject(ToastService);
    private readonly l10n = <L10nBase>inject(L10n);

    private readonly logger = new ConsoleLogger();

    public copy(value: string): void {
        if (!value) return;

        try {
            ClipboardUtils.copy(value);
            this.toastService.showAsync({text: this.l10n._T('scenes.shared.copy-to-clipboard.success'), type: 'info', duration: ToastDelay.VeryShort});
        } catch (err) {
            this.logger.error(err);
        }
    }
}
